import {notFound} from '@tanstack/react-router'
import {createServerFn} from '@tanstack/react-start'
import {z} from 'zod'
import fetchAboutPage from '~/client/sanity/fetchAboutPage'
import {applyServerFnCache} from '~/client/fn/utils'
import {Locale} from '~/gql/graphql'

const CACHE_TIME_SEC = 60 * 60 * 6 // 6h

const aboutPageContentParams = z.object({
    locale: z.nativeEnum(Locale).optional(),
})

const getAboutPageContent = createServerFn({
    method: 'GET',
})
    .inputValidator((data: unknown) => {
        const result = aboutPageContentParams.safeParse(data)
        if (result.error) {
            throw notFound()
        }

        return result.data
    })
    .handler(async ({data}) => {
        const {locale} = data ?? {}
        const aboutPageContent = await fetchAboutPage(locale)

        applyServerFnCache(CACHE_TIME_SEC)

        return aboutPageContent
    })

export default getAboutPageContent
